import HWTab from './HWTab'

export default HWTab


// WEBPACK FOOTER //
// ./src/components/ChannelTabs/HWTab/index.js